import React, {Component, Fragment} from 'react'
import {inject, observer, PropTypes as ObservablePropTypes} from 'mobx-react';
import {reaction} from 'mobx';
import PropTypes from 'prop-types'
import moment from 'moment'
import {Collapse} from 'reactstrap'

import sessionStore from '../../../services/session/SessionStore';
import {NameChip, Spinner, MarkdownRenderer, MarkdownEditor} from "../../../components";
import './pseudo-table.scss';
import {TryEdit} from "./TryEdit";




export const TaskTimeline = inject("userResolver", "taskStore")(observer(class TaskTimeline extends Component {
  timelineContainer;

  constructor(props){
    super(props);
    this.timelineContainer = React.createRef;
    reaction(() => this.props.taskStore.isEditMode, (mode) => {
      //scroll to the edit when going into edit mode, 0 was always caught in a race condition
      setTimeout(() => $("#wfTimelineContainer").scrollTop(Number.MAX_SAFE_INTEGER), 10);
    });

  }

  componentDidMount(){
    setTimeout(() =>  $("#wfTimelineContainer").scrollTop(Number.MAX_SAFE_INTEGER), 10);
  }


  //this user is different than the
  renderAuthorChip() {
    const {user} = sessionStore;
    if(!user){
      return <Spinner />
    }else{
      return <NameChip size="md" name={user.firstName ? `${user.firstName} ${user.lastName}`.trim() : user.username}/>
    }
  }


  render() {
    return (
      <div className="form-group position-relative">
        <label className="font-weight-bold">Task Activity</label>
        <div id="wfTimelineContainer" ref={this.timelineContainer} style={{maxHeight: '400px', overflowY: 'auto'}}>
          {
            this.props.taskStore.contentEditHistory.slice().map((edit, i) =>
              /* history is append only so index suffices as a stable key */
              <TimelineItem
                key={i}
                index={i}
                user={
                  edit.author.type !== 'User' ? undefined : this.props.userResolver.fetchOne(edit.author.id)
                }
                history={this.props.taskStore.contentEditHistory}
                task={this.props.taskStore.original}
                taskEdit={edit}/>
            )
          }
          <div className="d-flex mb-2 timeline-item">
            <div className="p-2 chip-container">
              <div className="timeline-bar" />
              {this.renderAuthorChip(sessionStore.user)}

            </div>
            <div className='mb-2 p-2 flex-fill form-group'>
              {/*<input placeholder="Enter Note" type="text" className="form-control" />*/}
              <TimelineComment />
            </div>
          </div>
        </div>
      </div>
    );
  }
}));

const TimelineItem = observer(class TimelineItem extends Component {

  static propTypes = {
    user: ObservablePropTypes.observableObject,
    taskEdit: PropTypes.any.isRequired,
    index: PropTypes.number.isRequired
  };

  state = {
    opened: false
  }

  constructor(props) {
    super(props)
  }

  renderAuthor() {
    const {taskEdit, user} = this.props;
    if (taskEdit.author.type !== 'User') return <span className="text-muted">Task Generator</span>;
    else if (!user || !user.isLoaded) {
      return <Spinner size="sm" />
    } else {
      return user.user.username
    }
  }

  renderAuthorChip() {
    const {user} = this.props;
    if(!user || !user.isLoaded){
      return <Spinner size="sm"/>
    }else{
      return <NameChip size="md" className="z2000 position-relative" name={user.user.firstName ? `${user.user.firstName} ${user.user.lastName}`.trim() : user.user.username}/>
    }
  }


  renderHistoryItem(chip, title, body, createdTimestamp) {
    //some spaces weren't rendering so &nbsp;
    return (
      <div className="d-flex timeline-item">
        <div className="p-2 chip-container">
          <div className="timeline-bar" />
          {chip}
        </div>
        <div className='mb-2 p-2 flex-fill'>
          <div>{title}</div>
          {body}
          <small className="text-muted d-flex">
            <span className="ss-icon ss-clock" />&nbsp; Created by&nbsp;{this.renderAuthor()}&nbsp;at {moment(createdTimestamp).format('h:mma M/D/YY')}
          </small>
        </div>
      </div>
    );
  }

  render() {
    const {task, taskEdit,  index} = this.props;
    if(index === 0) {
      // First item is always created
      return this.renderHistoryItem(
        <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center position-relative z2000" style={{height: "2.25rem", width: "2.25rem"}} ><span className="ss-icon ss-list" /></div>,
        <Fragment>
          <strong>New task created. - { task.content.taskName }</strong>
          { task.content.description ? <Fragment><br/><MarkdownRenderer value={task.content.description}/> </Fragment> : undefined }
        </Fragment>,
        undefined,
        taskEdit.timestamp
      );
    } else if(taskEdit.changeDescriptions[0].indexOf('added comment') === 0) {
      // Task Comment
      // TODO find the last reference of commentId in edit log to get most recent comment
      if(taskEdit.changeDescriptions[0].toLowerCase().indexOf('shared by email to') !== -1) {
        return this.renderHistoryItem(
          <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center position-relative z2000" style={{height: "2.25rem", width: "2.25rem"}} ><span className="ss-icon ss-redirect"/> </div>,
          <MarkdownRenderer value={taskEdit.revert[0].old.body}/>,
          undefined,
          taskEdit.timestamp
        );
      } else if (taskEdit.changeDescriptions[0].toLowerCase().indexOf("external reply from ") !== -1) {
        return this.renderHistoryItem(
          <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center position-relative z2000" style={{height: "2.25rem", width: "2.25rem"}} ><span className="ss-icon ss-reply"/> </div>,
          <MarkdownRenderer value={taskEdit.revert[0].old.body}/>,
          undefined,
          taskEdit.timestamp
        );
      } else {
        return this.renderHistoryItem(
          this.renderAuthorChip(this.props.user),
          <MarkdownRenderer value={taskEdit.revert[0].old.body}/>,
          undefined,
          taskEdit.timestamp
        );
      }
    } else {
      const {opened} = this.state;
      return this.renderHistoryItem(
        <div className="rounded-circle bg-warning text-white d-flex align-items-center justify-content-center position-relative z2000" style={{height: "2.25rem", width: "2.25rem"}}><span className="ss-icon ss-edit"/> </div>,
        <div className="d-flex align-items-center"><strong>Task Edited </strong> <a className="btn btn-sm btn-link" style={{textTransform: "capitalize"}} onClick={() => this.setState({ opened: !opened})}>{ opened ? 'Hide' : 'Show'}</a></div>,
        <Collapse isOpen={opened}>
          <ul style={{marginBottom: ".25rem"}}>
            {taskEdit.changeDescriptions.map((change, index) => <li key={`${change}-${index}`}>{change}</li>)}
          </ul>
        </Collapse>,
        taskEdit.timestamp
      );
    }
  }

});

const TimelineComment = inject("taskStore")(observer(class TimelineComment extends Component {
  state = {
    comment: ""
  };

  onEdit = (value) => this.props.taskStore.editComment(value);

  render() {
    const {isEditMode: isEditing, isNewTask, comment} = this.props.taskStore;
    const containerSize = {maxHeight: '300px', overflow: 'auto'};

    if(isEditing){
      return (
        <Fragment >
          <MarkdownEditor
            autofocus={true}
            type="textarea" name="text" id="editTaskText"
            style={containerSize}
            value={comment}
            onChange={this.onEdit}
          />
        </Fragment>
      )
    } else {
      return (
        <TryEdit><MarkdownRenderer
          placeholder={'Add a Note'}
          style={{...containerSize}}
          value={comment}
        /></TryEdit>
      );
    }
  }
}));
